import { Typography } from "@mui/material";
import { useEffect, useState } from "react";

import HNSColors from "../../../../../../ui library/HNSColors";
import { isEmptyValue } from "../../../helper/functions";
import { useStaticData } from "../../../hooks/useStaticData";
import NothingToShow from "../../NothingToShow";

export default function TextField({ value, field = {} }) {
  const [displayValue, setDisplayValue] = useState(value);
  const availableInModel = field?.availableInModel ?? true;
  const { fetchDataValue } = useStaticData(field);

  useEffect(() => {
    if (!availableInModel) {
      fetchDataValue(value).then((response) => response && setDisplayValue(response));
    }
  }, [value, availableInModel]);

  if (isEmptyValue(displayValue)) {
    return <NothingToShow />;
  }

  return (
    <Typography className="text-[14px]" sx={{ color: HNSColors.neutrals[100] }}>
      {displayValue}
    </Typography>
  );
}
